/**
 * Created by Owner on 2016/10/22.
 * 组六复式
 */
import {Component} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {LotteryMath} from "./lotteryMath";
import {MathUtil} from "../../util/mathUtil";

//单选特殊
@Component({
  selector: 'lottery-math-dxtx',
  templateUrl: 'selectMathAndPostion.html',
})
export class LotteryMathDXTXComponent extends LotteryMathZXFSComponent implements LotteryMath {
  max_place: number = 0;

  ngOnInit() {
    this.selectAreaOption["layout"].forEach(item=> {
      if (item.place > this.max_place) {
        this.max_place = item.place;
      }
    });
  }

  changeTotal() {
    let mname = this.selectAreaOption["mname"];
    let tmpTotal: number = 0;
    let data_sel = this.children.toArray();
    let isrx = this.selectAreaOption["isrx"];
    let selLenth = this.defaultPosition.length;
    let optionLg = 2;
    if (mname == "ZUS") {
      for (let i = 0; i <= this.max_place; i++) {
        var s = data_sel[i]["selectNo"].length;
        if (s > 1) {
          tmpTotal += s * (s - 1);
        }
      }
      optionLg = 3;
    }
    if (mname == "ZUL") {
      for (let i = 0; i <= this.max_place; i++) {
        var s = data_sel[i]["selectNo"].length;
        if (s > 2) {
          tmpTotal += s * (s - 1) * (s - 2) / 6;
        }
      }
      optionLg = 3;
    }
    if (mname == "ZU2" || mname == "BDW2") {
      for (let i = 0; i <= this.max_place; i++) {
        var s = data_sel[i]["selectNo"].length;
        if (s > 1) {
          tmpTotal += s * (s - 1) / 2;
        }
      }
      optionLg = 2;
    }
    if (mname == "BDW3") {
      for (let i = 0; i <= this.max_place; i++) {
        var s = data_sel[i]["selectNo"].length;
        if (s > 2) {
          tmpTotal += MathUtil.combination(data_sel[i]["selectNo"].length, 3);
        }
      }
    }
    if (isrx == 1) {
      tmpTotal *= selLenth == 0 ? 0 : MathUtil.combination(selLenth, optionLg);
    }
    this.setTotal(tmpTotal);
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/dxtx.ts